export const delay = ms => new Promise(res => setTimeout(res, ms));

export const DATA_PER_PAGE = 100;

export const getLocationRequestQuery = (pageNumber = 1) => ({
  filter: '',
  pagination: {
    pageNumber,
    size: DATA_PER_PAGE,
    sort: [
      {
        property: 'requestTime',
        direction: 'DESC',
      },
    ],
  },
});

export const getPastStudentAbsencesQuery = (toDate, pageNumber = 1) => ({
  filter: '',
  pagination: {
    pageNumber,
    size: 10,
    sort: [
      {
        property: 'fromTime',
        direction: 'DESC',
      },
    ],
  },
  toDate,
});

export const getUpcomingStudentAbsencesQuery = fromDate => ({
  filter: '',
  fromDate,
  pagination: {
    pageNumber: 1,
    size: 100,
    sort: [
      {
        property: 'fromTime',
        direction: 'DESC',
      },
    ],
  },
});

export const STUDENT_ADULTHOOD = 18;

export const ABSENCE_REASONS = {
  HEALTH: 'HEALTH',
  FAMILY: 'FAMILY',
  OTHER: 'OTHER',
};

export const AUTH_ERROR_TYPES = {
  IDENTIFIER: 'identifier',
  IDENTIFIER_PASS: 'identifierPassword',
  NEW_PASS: 'newPassword',
  TEMPORARY_PASS: 'temporaryPassword',
  VERIFICATION_CODE: 'verificationCode',
};

export const TENANT_ID_KEY = 'X-TenantID';
export const AUTH_TOKEN_KEY = 'Authorization';
export const CHILDREN_PER_PAGE = 20;
export const STAFF_PER_PAGE = 20;

export const DATE_FORMAT = {
  ABSENCE_CLIENT_TIME_FORMAT: 'dd, MMMM D, HH:mm',
  ABSENCE_CLIENT_TIME_FORMAT_FULL_DAY: 'dd, MMMM D',
  ABSENCES_DASHBOARD_TIME_PERIOD: 'HH:mm',
  ANNOUNCED_ABSENCE_TIME_FORMAT: 'DD.MM.YYYY HH:mm',
  SUBTITLE: 'dddd, MMMM DD',
  ALARM_FILTER_DATE_FORMAT: 'DD.MM.YYYY',
  AGENDA_DATE: 'YYYY-MM-DD',
  ABSENCES_DATE: 'YYYY-MM-DD',
  ECA_SERVER_DATE: 'YYYY-MM-DD',
  ECA_CLIENT_DATE: 'DD/MM/YYYY',
  ECA_CLIENT_NICEDATE: 'DD MMMM YYYY',
  ECA_CLIENT_TIME: 'HH:mm',
  SERVER_DATE_TIME: 'YYYY-MM-DDTHH:mm:ssZZ',
  CLIENT_DATE_TIME: 'HH:mm, DD.MM.YYYY',
  HISTORY_DATE_TIME: 'DD.MM.YYYY, HH:mm:ss',
  HISTORY_DATE_TIME_NO_SECONDS: 'DD.MM.YYYY, HH:mm',
  HISTORY_DATE: 'DD.MM.YYYY',
  HISTORY_TIME: 'H:mm',
  DEACTIVATED_DATE: 'DD.MM.YYYY',
  NEWS_PUBLISH_DATE: 'DD.MM.YYYY HH:mm',
  LAST_USER_IN_DATE: 'DD.MM.YYYY HH:mm',
};

// do not change order
export const DAY_WEEKS_TRANSLATIONS = {
  MONDAY: 'weekdays.short.monday',
  TUESDAY: 'weekdays.short.tuesday',
  WEDNESDAY: 'weekdays.short.wednesday',
  THURSDAY: 'weekdays.short.thursday',
  FRIDAY: 'weekdays.short.friday',
  SATURDAY: 'weekdays.short.saturday',
  SUNDAY: 'weekdays.short.sunday',
};

export const DEFAULT_LOCALE = 'en';

export const HISTORY_DIRECTIONS = {
  ALL: {
    LABEL: 'labels.all',
    VALUE: 'ALL',
  },
  WAY_TO: {
    LABEL: 'labels.wayTo',
    VALUE: 'WAY_TO',
  },
  WAY_BACK: {
    LABEL: 'labels.wayBack',
    VALUE: 'WAY_BACK',
  },
};

export const HISTORY_FILTERS = {
  DIRECTION: 'direction',
  END_PERIOD: 'endPeriod',
  ROUTE_NAME: 'routeName',
  START_PERIOD: 'startPeriod',
  STATUS: 'status',
};

export const HISTORY_STATUSES = {
  ALL: {
    LABEL: 'labels.all',
    VALUE: 'ALL',
  },
  ABORTED: {
    LABEL: 'routes.history.state.aborted',
    VALUE: 'ABORTED',
  },
  COMPLETED: {
    LABEL: 'routes.history.state.completed',
    VALUE: 'COMPLETED',
  },
};

export const ECA_HISTORY_FILTERS = {
  EVENT_NAME: 'eventName',
  ACTIVITY_NAME: 'activityName',
  PROGRAM_NAME: 'programName',
  START_PERIOD: 'startPeriod',
  END_PERIOD: 'endPeriod',
  STATUS: 'status',
};

export const ECA_HISTORY_STATUSES = {
  ALL: { VALUE: 'ALL', LABEL: 'eca.history.status.all' },
  STANDBY: { VALUE: 'STANDBY', LABEL: 'eca.history.status.standby' },
  STARTED: { VALUE: 'STARTED', LABEL: 'eca.history.status.started' },
  FINISHED: { VALUE: 'FINISHED', LABEL: 'eca.history.status.finished' },
};

export const LOCALE = 'Locale';

export const LOCALES = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
  {
    languageId: 'deutsch',
    locale: 'de',
    name: 'Deutsch',
    icon: 'de',
  },
  {
    languageId: 'french',
    locale: 'fr',
    name: 'Français',
    icon: 'fr',
  },
  {
    languageId: 'japanese',
    locale: 'ja',
    name: '日本語',
    icon: 'jp',
  },
];

export const NOTICES = {
  SCHOOL_TYPES: {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
  },
  RECIPIENTS: {
    ALL_DRIVERS: 'ALL_DRIVERS',
    ALL_PARENTS: 'ALL_PARENTS',
    ALL_STAFF: 'ALL_STAFF',
    ALL_STUDENTS: 'ALL_STUDENTS',
  },
  TYPES: {
    DELAY: 'DELAY',
    DIVERSION: 'DIVERSION',
    GENERAL: 'GENERAL',
    SECURITY: 'SECURITY',
  },
};

export const NOTICES_TAB_TYPES = {
  INBOX: 'INBOX',
  SENT: 'OUTBOX',
  HISTORY: 'HISTORY',
};

export const NOTICE_RESPONSE = {
  YES: 'YES',
  NO: 'NO',
};

export const NOTICE_TYPES = {
  DELAY: 'DELAY',
  DIVERSION: 'DIVERSION',
  SECURITY: 'SECURITY',
  GENERAL: 'GENERAL',
};

export const NOTIFICATIONS_TYPE = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export const PAGE_NUMBER_QUERY_KEY = 'page';

export const QUERIES = {
  FROM_WAY_TO: 'from_way_to',
  FROM_WAY_BACK: 'from_way_back',
  MANAGE_PAGE_STATE: 'manage_page_state',
};

export const REQUESTS_DEBOUNCE_TIMEOUT = 250;
export const PRELOAD_ALARM_MESSAGES_DEBOUNCE_TIMEOUT = 300;
export const ROUTE_BY_ID_MISSING = 'route_missing';

export const ROUTE_DIRECTIONS = {
  WAYBACK: 'wayBack',
  WAYTO: 'wayTo',
};

export const STATUS_QUERY_KEY = 'accountFilter';
export const IDENTIFIER_QUERY_KEY = 'filter';
export const ROLE_QUERY_KEY = 'role';
export const ROUTE_ID_QUERY = 'route_id';

export const ROUTE_OPERATIONS = {
  DOWN: 'DOWN',
  UP: 'UP',
};

export const ROUTE_RELATION_KEYS = {
  BUSES_IDS: 'busesIds',
  DRIVERS_IDS: 'driversIds',
};

export const PAGINATION_PER_PAGE = [100, 500, 1000];
export const ROUTES_PER_PAGE = 200;
export const ROWS_PER_PAGE_QUERY_KEY = 'rows';
export const SCHEDULE_CLIENT_TIME_FORMAT = 'HH:mm';
export const SCHEDULE_SERVER_TIME_FORMAT = 'HH:mm:ssZZ';
export const MARKER_POPUP_TIME_FORMAT = 'HH:mm';

export const SOCKET_NOTIFICATIONS_TYPES = {
  UPDATE_ROUTE: 'UPDATE_ROUTE',
  UPDATE_PASSENGER_ROUTE: 'UPDATE_PASSENGER_ROUTE',
  UPDATE_ALARMS_COUNT: 'SOS_ALARM',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  ALIVE_CONNECTION: 'ALIVE_CONNECTION',
  REFRESH_OVERVIEW: 'REFRESH_OVERVIEW',
  UPDATE_ECA_EVENT: 'UPDATE_ECA_EVENT',
  // Manage Routes V2 dataset editor (spec 5.3). Frame:
  // `{event: 'ROUTES_DATASET_CHANGED', ids: ['OPS'] | ['IMPORT'] | ['ACTIVATION', id]}`.
  // Being a member of THIS map is also what gives the section its reconnect refetch:
  // `sagas/WSNotifications.js` `fetchDataOnConnect` replays every type here as a
  // synthetic frame with no `ids`.
  ROUTES_DATASET_CHANGED: 'ROUTES_DATASET_CHANGED',
};

export const THEME_PRIMARY_ACCENT_COLOR = '#025c91';
export const ERROR_DARK_COLOR = '#ac1614';
export const THEME_SECONDARY_ACCENT_COLOR = '#8bc34a';

export const WEEKDAYS = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
};

// what days should be available to pick and in what order
export const ROUTE_WORK_DAYS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export const SCHEDULE_DEFAULT_TIME = {
  ARRIVE_WAY_TO: '08:00',
  DEPART_WAY_BACK: '15:00',
};

// what days should the Create Route dialog show active by default
export const DEFAULT_ROUTE_DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];

export const USER_ROLES = {
  ADMIN: 'administrator',
  CTM: 'crisis_team_member',
  STAFF: 'staff',
  STUDENT: 'student',
  TM: 'transportation_manager',
  COMMUNICATION: 'communication_manager',
  SECURITY: 'security_manager',
  SUPERVISOR: 'supervisor',
  ECA_MANAGER: 'eca_manager',
  ECA_ACTIVITY_LEAD: 'eca_activity_lead',
};

export const TS_MODULE = {
  ECA: '/api/v1/eca',
  EMERGENCY: '/api/v1/emergency',
  INFO: '/api/v1/info',
  TRANSPORT: '/api/v1/transportation',
};

export const PASSWORD_REGEXP = new RegExp(
  '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*\\-_,.|:><]).{8,}$',
);

export const NOTICE_HISTORY_FILTER_KEYS = {
  START_PERIOD: 'startPeriod',
  END_PERIOD: 'endPeriod',
};

export const ALARM_TYPES = {
  ALL: {
    LABEL: 'alarms.type.all',
    VALUE: 'ALL',
  },
  BUS: {
    LABEL: 'alarms.type.bus',
    VALUE: 'BUS',
  },
  DAKS: {
    LABEL: 'alarms.type.daks',
    VALUE: 'DAKS',
  },
  PERSONAL: {
    LABEL: 'alarms.type.personal',
    VALUE: 'PERSONAL',
  },
  FIRE: {
    LABEL: 'alarms.type.fire',
    VALUE: 'FIRE',
  },
  LOCK_DOWN: {
    LABEL: 'alarms.type.lockdown',
    VALUE: 'LOCK_DOWN',
  },
};

export const SOS_TIMER_VALUE = 60;

export const INVALID_DATE = 'Invalid date';

export const USERS_QUERY_PARAMS = {
  identifier: 'filter',
  role: 'role',
  accountFilter: 'accountFilter',
};

export const ABSENCES_ALL_CAMPUSES = {
  ID: 'all',
  EXT_NAME: 'absences.campuses.all',
};

export const ABSENCES_FILTERS = {
  NAME: 'name',
  DATE: 'date',
  CAMPUS: 'campusId',
  GRADE: 'grade',
  CLASS: 'form',
  ROUTE: 'route',
};

export const CALL_SESSION_STATUSES = {
  STARTED: 'STARTED',
  ALREADY_STARTED: 'ALREADY_STARTED',
  CALL_DIRECT: 'CALL_DIRECT',
};

export const DELAY_REASONS_TRANSLATIONS = {
  HEAVY_TRAFFIC: 'delay.reason.heavyTraffic',
  ROAD_CONSTRUCTION: 'delay.reason.roadConstruction',
  OTHER_REASON: 'delay.reason.otherReason',
  ON_SCHEDULE: 'delay.reason.onSchedule',
};

export const STATISTICS_QUERY_PARAMS = {
  CATEGORY_ID: 'categoryId',
  FROM: 'from',
  TO: 'to',
  LEVEL: 'level',
};

export const EXTRA_STOP = 'extra stop';

export const ABSENCE_END_BY_DATE = 'date';
export const ABSENCE_END_BY_OCCURRENCE = 'occurrence';
export const MAX_REPEATS_FOR_ABSENCE = 52;

export const TEXT_COMMENT_MAX_LENGTH = 255;
export const NOTICE_BODY_MAX_LENGTH = 999;
export const TEXT_TITLE_MAX_LENGTH = 60;
export const TEXT_CONTACTS_MAX_LENGTH = 254;
export const VEHICLE_NAMES_MAX_LENGTH = 16;
export const PERSON_NAME_MAX_LENGTH = 127;
export const TEXT_PHONE_NUMBER_MAX_LENGTH = 16;
export const BUS_SEATS_MIN_COUNT = 1;
export const BUS_SEATS_MAX_COUNT = 999;

export const EN = 'en';
export const DE = 'de';
export const JP = 'ja';

export const DEFAULT_REPORT_NAME = {
  PREFIX: 'RouteHistoryReport_',
  PREFIX_TIMESHEET: 'TimesheetHistoryReport_',
  PREFIX_LOCATION_HISTORY: 'LocationHistoryReport_',
  POSTFIX_FULL: '_full',
  POSTFIX_FILTERED: '_filtered',
};

export const ACTIVE_CAMPUSES = 'activeCampuses';
export const ACTIVE_DIRECTORIES = 'activeDirectories';
export const ARRIVAL_BAR_PREF = 'arrivalBarPreference';
export const UNKNOWN_CAMPUS_ID = 'pages.routesOverview.unknownCampus';
export const SELECT_MODE = 'selectMode';

export const MARKER_TYPE = {
  BUS: 'BUS',
  PLANNED_STATION: 'PLANNED_STATION',
  UNPLANNED_STATION: 'UNPLANNED_STATION',
  LOCATION_HISTORY: 'LOCATION_HISTORY',
  PUPIL_STOP_TEMPLATE: 'PUPIL_STOP_TEMPLATE',
  ROUTE_STOP_TEMPLATE: 'ROUTE_STOP_TEMPLATE',
};

export const DIRECTION_TYPES = {
  FULL: 'FULL',
  WAY_TO: 'AM',
  WAY_BACK: 'PM',
};

export const MAX_MARKERS_COUNT = 100;

export const ROUTE_SELECT_CAMPUS_ITEM = {
  ID: '',
  EXT_NAME: 'routed.dialog.campus.select',
};

export const LOG_TABLE_STATUSES = {
  EMBARKED: 'status.logTable.statusColumn.embarked',
  DISEMBARKED: 'status.logTable.statusColumn.disembarked',
  DID_NOT_MISS: 'status.logTable.statusColumn.didNotMiss',
  REPORTED_ABSENT: 'status.logTable.statusColumn.reportedAbsent',
  MISSED: 'status.logTable.statusColumn.missed',
  DID_NOT_EMBARK: 'status.logTable.statusColumn.didNotEmbark',
  DID_NOT_DISEMBARK: 'status.logTable.statusColumn.didNotDisembark',
};

export const TIMESHEET = 'TIMESHEET';
export const ROUTE_REPORT = 'ROUTE_REPORT';
export const LOCATION_REPORT = 'LOCATION_REPORT';

// ---------------------------------------------------------------------------
// Diversion feature constants
// ---------------------------------------------------------------------------

// Server-side enum mirrors. Source of truth:
//   - educe-tec/.../transportation/domain/model/DriverDiversionStatus.java
//   - educe-tec/.../transportation/domain/model/DiversionPolicy.java
// Keep value strings identical to server enum names — Jackson serialises
// enum-by-name, so any drift breaks deserialisation on the wire.
export const DIVERSION_STATUSES = {
  PENDING: 'PENDING',
  DIVERTING: 'DIVERTING',
  SHELTERED: 'SHELTERED',
  BACK_ON_ROUTE: 'BACK_ON_ROUTE',
};

export const DIVERSION_POLICIES = {
  NONE: 'NONE',
  NEAREST: 'NEAREST',
  FASTEST: 'FASTEST',
};

// Client-side derived display states. Superset of DIVERSION_STATUSES — adds
// UNACKNOWLEDGED (PENDING > 5 min), PREMATURE_ABORT (route aborted before
// shelter), CANCELLATION_PENDING (cancelledAt != null). Derived by
// deriveDiversionDisplayState(diversion, routeState, now) in src/util/diversion.js.
export const DIVERSION_DISPLAY_STATES = {
  PENDING: 'PENDING',
  UNACKNOWLEDGED: 'UNACKNOWLEDGED',
  DIVERTING: 'DIVERTING',
  SHELTERED: 'SHELTERED',
  PREMATURE_ABORT: 'PREMATURE_ABORT',
  CANCELLATION_PENDING: 'CANCELLATION_PENDING',
};

// Banner / chip background colour per derived display state.
export const DIVERSION_STATE_COLORS = {
  PENDING: '#ff9800', // amber
  UNACKNOWLEDGED: '#e53935', // red — escalation
  DIVERTING: '#2196f3', // blue
  SHELTERED: '#4caf50', // green
  PREMATURE_ABORT: '#e53935', // red — same escalation tier as UNACKNOWLEDGED
  CANCELLATION_PENDING: '#66bb6a', // lighter green
};

// Material UI icon-name labels for the two escalation states. Task 08
// (DiversionStateBanner) imports the React component directly:
//   import PriorityHigh from '@mui/icons-material/PriorityHigh';
// This map is just a label discriminator (matches the "labels as strings"
// convention elsewhere in this file). PI-5 resolved: material-ui-icons
// v1.0.0-beta.36 ships PriorityHigh.js — no fallback needed.
export const DIVERSION_STATE_ICONS = {
  UNACKNOWLEDGED: 'PriorityHigh',
  PREMATURE_ABORT: 'PriorityHigh',
};

// PENDING flips to UNACKNOWLEDGED after this many minutes (client-side
// derivation, no server-side equivalent). 30s tick in the banner / overview
// row containers recomputes against this threshold.
export const UNACKNOWLEDGED_THRESHOLD_MINUTES = 5;

// Body-format separator. Server's DiversionPayloadParser splits on the same
// literal token (educe-tec/.../parser/DiversionPayloadParser.java:51). Always
// use indexOf, never split — a preamble that legitimately contains '\n---'
// would fragment otherwise.
export const DIVERSION_YAML_SEPARATOR = '\n---';
